/* screens/kitchen/IngredientLegacyRedirect.jsx — роут /kitchen/:id (legacy full-page).
   Фикс боли №4: drawer становится каноном. Редирект на
   /kitchen?tab=ingredients&edit=card-{id}. KitchenCardDetail не реализуем.
   ХЕНДОФФ → frontend/src/pages/kitchen/KitchenCardDetail.jsx (заменить на редирект). */

import { RR } from '../../lib/router.jsx';

  const { useParams, Navigate } = RR;
  function IngredientLegacyRedirect() {
    const { id } = useParams();
    return <Navigate to={'/kitchen?tab=ingredients&edit=card-' + id} replace />;
  }

export { IngredientLegacyRedirect };
